import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

/**
 * Skeleton — заглушка загрузки «Картотека». Радиус карточки + утопленный
 * well-фон, мягкая пульсация. Соответствует радиусу/тени реального контента.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn("sh-inset-field animate-pulse rounded-[var(--radius-md)]", className)}
			{...props}
		/>
	);
}
Skeleton.displayName = "Skeleton";
